import { render, staticRenderFns } from "./confirmacionWPP.vue?vue&type=template&id=3b3dd80a&scoped=true&"
import script from "./confirmacionWPP.vue?vue&type=script&lang=js&"
export * from "./confirmacionWPP.vue?vue&type=script&lang=js&"
import style0 from "./confirmacionWPP.vue?vue&type=style&index=0&id=3b3dd80a&lang=scss&scoped=true&"
import style1 from "./confirmacionWPP.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3dd80a",
  null
  
)

export default component.exports